angular.module('gym.calendar').directive('eventOnlineMeetingDetail', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/event_online_meeting_detail.html.slim'),
    scope: {
      event: '='
    },
    controller: ["$scope", "$modal", "EmploymentService", function($scope, $modal, EmploymentService) {
      $scope.permissions = EmploymentService.get().permissions;
      return $scope.openMeetingDetails = function() {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/gyms/calendar/set_meeting_details.html.slim'),
          resolve: {
            event: function() {
              return $scope.event;
            }
          },
          controller: 'SetMeetingDetailsCtrl'
        });
        return modalInstance.result.then(function(data) {
          $scope.event.meeting_url = data.meeting_url;
          return $scope.event.meeting_instructions = data.meeting_instructions;
        });
      };
    }]
  };
});
